import { createEvent, createStore, sample } from '@lib/state-engine';
import persist from 'effector-localstorage';

export const MODES: Modes = [
  { value: 'map', label: 'Карта' },
  { value: 'list', label: 'Список' },
];

export const setViewMode = createEvent<ViewMode>();
export const $selectedViewMode = createStore(MODES[0]).on(setViewMode, (_, mode) =>
  mode === 'map' ? MODES[0] : MODES[1],
);

persist({
  store: $selectedViewMode,
  key: 'view-mode',
  def: MODES[0],
  sync: true,
});

type Mode = {
  value: ViewMode;
  label: string;
};

type Modes = Mode[];

export type ViewMode = 'map' | 'list';

sample({
  clock: setViewMode,
  fn: (mode) => {
    if (mode === 'map') {
      return MODES[0];
    }

    if (mode === 'list') {
      return MODES[1];
    }

    return MODES[0];
  },
  target: $selectedViewMode,
});
